module.exports = __webpack_public_path__ + "img/ico6.23094c0a.png";